import React from 'react';
import { Button, Space } from 'antd';
import { ExternalLink } from 'lucide-react';
import { IPenalty } from '@services/penalty';

const CellExternalLinks = ({ data }: { data: IPenalty }): JSX.Element => {
  const handleOpenShipperPortal = () => {
    if (data.sennder_reference) {
      window.open(
        `https://shippers.sennder.com/shipments/${data.sennder_reference}`,
        '_blank',
      );
    }
  };

  const handleOpenTrafficTool = () => {
    if (data.line_code && data.order_date) {
      // Format order_date to YYYY-MM-DD if it's not already
      let formattedDate = data.order_date;
      if (data.order_date) {
        const date = new Date(data.order_date);
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          formattedDate = `${year}-${month}-${day}`;
        }
      }
      window.open(
        `https://traffic.sennder.it/lane/${data.line_code}?leg=${data.route_composition}&order_date=${formattedDate}`,
        '_blank',
      );
    }
  };

  return (
    <Space direction="vertical" size="small">
      {data.sennder_reference && (
        <Button
          type="link"
          size="small"
          icon={<ExternalLink size={12} />}
          onClick={handleOpenShipperPortal}
          style={{ padding: 0, height: 'auto' }}
        >
          Shipper Portal
        </Button>
      )}
      {data.line_code && data.order_date && (
        <Button
          type="link"
          size="small"
          icon={<ExternalLink size={12} />}
          onClick={handleOpenTrafficTool}
          style={{ padding: 0, height: 'auto' }}
        >
          Traffic Tool
        </Button>
      )}
    </Space>
  );
};

export default CellExternalLinks;
